import HTTPHandler from 'lib/api/HTTPHandler'
import { CS_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class SalesService {
  static updateSalesSubdivision = async data => {
    try {
      const result = await HTTPHandler.post(
        CS_API_URL + '/sales/subdivision',
        data
      )
      return { status: result?.status, data: result?.data }
    } catch (e) {
      return createError(e)
    }
  }
}
